import React from 'react';

export const AutomationContext = React.createContext();
